import {
  getNotificationList,
  pathCreateNotification,
  pathDeleteNotification,
  getNotificationListDetail,
  getNotificationSystemList,
  pathUpdateSystemNotification,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { notificationActions } from "../reducers/notification";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchNotificationList = (id_notification = 0) => {
  return (dispatch) => {
    return apiService
      .get(getNotificationList(id_notification))
      .then((response) => {
        id_notification == 0
          ? dispatch(notificationActions.fetchNotificationList(response.data))
          : dispatch(
              notificationActions.fetchNotificationDetail(response.data)
            );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchNotificationListDetails = (id_notification = 0) => {
  return (dispatch) => {
    return apiService
      .get(getNotificationListDetail(id_notification))
      .then((response) => {
        dispatch(
          notificationActions.fetchNotificationListDetails(response.data)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchNotificationSyestemList = (id_notification = 0) => {
  return (dispatch) => {
    return apiService
      .get(getNotificationSystemList(id_notification))
      .then((response) => {
        id_notification == 0
          ? dispatch(
              notificationActions.fetchNotificationSystemList(response.data)
            )
          : dispatch(
              notificationActions.fetchNotificationSyeDetail(response.data)
            );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchClearDetailNotification = () => {
  return (dispatch) => {
    dispatch(notificationActions.fetchNotificationDetail([]));
  };
};

export const createNewNotification = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateNotification(), data)
      .then((response) => {
        // dispatch(countryActions.fetchCountryList(response.data));
        toast.success(t("notificationsListActions.created"), {
          theme: "colored",
        });
        navigate("/notification-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewNotification1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateNotification(), data)
      .then((response) => {
        // dispatch(notificationActions.fetchNotificationList(response.data));
        toast.success(t("notificationsListActions.created"), {
          theme: "colored",
        });
        navigate("/notification-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditNotification = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateNotification(), data)
      .then((response) => {
        // dispatch(notificationActions.fetchNotificationList(response.data));
        toast.success(t("notificationsListActions.updated"), {
          theme: "colored",
        });
        navigate("/notification-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchUpdateSystemNotification = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathUpdateSystemNotification(), data)
      .then((response) => {
        // dispatch(notificationActions.fetchNotificationList(response.data));
        toast.success(t("notificationsListActions.updated"), {
          theme: "colored",
        });
        navigate("/notification-list-system");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteNotification = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteNotification(id))
      .then((response) => {
        toast.success(t("notificationsListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchNotificationList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
